let shouldReload = true;


export function InitDFP() {

    let adSlotTemplate;
    // if handlebars is defined
    if (typeof Handlebars !== 'undefined') {
        // register a helper called json
        // this helper will stringify the context passed to it
        Handlebars.registerHelper('json', function (context) {
            return JSON.stringify(context);
        });
        adSlotTemplate = Handlebars.compile($('#ad-slot-template').html());
    }
    //Polyfills
    Number.isNaN = Number.isNaN || function (value) {
        return value !== value;
    }


    const pages = {};
    window.dfpAdsPage = null;


    window.addMovedViewportListener(function (element, initialMove) {
        $(window).trigger('init-scroll-checks');
        if (initialMove) {
            return;
        }
        const id = element.contents.attr("id");
        refreshAdByName(id);
    });


    window.checkAdsInitialized = function (thisPage) {

        if (!thisPage)
            return;

        const gpt = window.googletag;
        Object.keys(thisPage.adSlots).forEach(function (name) {
            const slot = thisPage.adSlots[name];
            if (slot.isInitialized) {
                return;
            }

            //var scrolledIntoView = isScrolledIntoView(holder);
            //if (scrolledIntoView) {
            slot.isInitialized = true;

            gpt.cmd.push(function () {
                slot.dfpSlotName = thisPage.slotName;

                let name = thisPage.slotName + '/' + slot.holderId;
                let slotDefinition = slot.outOfPage ? gpt.defineOutOfPageSlot(name, slot.holderId) : gpt.defineSlot(name, slot.defaultSize, slot.holderId);
                slot.googleSlot = slotDefinition
                    .setTargeting('position', [slot.holderId])
                    .addService(gpt.pubads());
                if (slot.sizeMapping) {
                    slot.googleSlot.defineSizeMapping(slot.sizeMapping);
                }
                const qp = getParameterByName("adtest");
                if (qp) {
                    gpt.pubads().setTargeting("adtest", [qp]);
                }
            });
            //}
        });
    };

    function unstickAd(slot) {
        setTimeout(function () {
            slot.container.removeClass('sticky-dfp-ad');
            // also remove the sticky-dfp-ad class from all the parents
            slot.container.parents().removeClass('sticky-dfp-ad');
        }, 500);
    }

    function getFormattedTimestamp() {
        const now = new Date();
        return now.toLocaleString('en-GB', {hour12: false}) + '.' + now.getMilliseconds();
    }

    window.getDFPAds = function (thisPage, callback) {
        console.time('getDFPAds')
        const gpt = window.googletag;
        gpt.cmd.push(function () {
            gpt.pubads().clearTargeting();
            gpt.pubads().disableInitialLoad();
            gpt.pubads().collapseEmptyDivs(true, true);
            gpt.pubads().addEventListener('impressionViewable', function (e) {
                const slot = window.dfpAdsPage.adSlots[e.slot.getSlotElementId()];
                if (!slot) {
                    return;
                }
                unstickAd(slot);
            });
            gpt.pubads().addEventListener('slotOnload', function (e) {
                const slot = window.dfpAdsPage.adSlots[e.slot.getSlotElementId()];
                if (!slot) {
                    return;
                }
                // log the time the ad was loaded to the millisecond to the console
                // console.debug('Ad Loaded: ' + slot.holderId, getFormattedTimestamp());
                console.timeEnd(e.slot.getSlotElementId());
                console.timeLog('getDFPAds', e.slot.getSlotElementId());
                setTimeout(function () {
                    unstickAd(slot);
                }, thisPage.maxPinTime);
            });
        });
        console.timeLog('getDFPAds', 'checkAdsInitialized')
        checkAdsInitialized(thisPage);


        gpt.cmd.push(function () {
            gpt.pubads().enableSingleRequest();
        });

        //Enqueueing first Ad
        setupAdMovement(thisPage);

        moveMobileReplacementsToBodyCopy(thisPage);

        console.timeLog('getDFPAds', 'moveMobileReplacementsToBodyCopy');
        window.reloadCurrentPageAds();
        console.timeLog('getDFPAds', 'reloadCurrentPageAds');
        window.moveElementsToCurrentViewport(true);

        gpt.cmd.push(function () {
            setTargeting(gpt, thisPage);
            gpt.enableServices();
        });

        if (callback) {
            callback();
        }
    };

    function setupInlineArticleAds(thisAdSection, adSlotTemplate) {
        // check if there's any body copy, and if so, add inline adverts
        const bodyCopy = thisAdSection.find('[data-ads-body-copy]');
        if (bodyCopy.length > 0) {
            // check if it's already been done
            if (bodyCopy.data('ads-parsed')) {
                return;
            }

            // find the sizes from a hidden called data-article-ad-sizes
            const adSizes = thisAdSection.find('[data-article-ad-sizes]');
            // if we have sizes, then we can add the inline adverts
            if (adSizes.length > 0) {
                // first, get the size mappings
                const sizeMappings = adSizes.data('article-ad-sizes');
                // next, find the current viewport
                const isDesktop = !!window.isViewportGreaterThanOrEqualTo('md');

                const wordsPerAd = isDesktop ? 300 : 200;

                // now, we want to work our way through the body copy, and add an advert after every 'wordsPerAd' words
                // first, get all the paragraphs
                // Get all paragraphs
                let allParagraphs = bodyCopy.find('p');

                // Filter out paragraphs within tables
                const paragraphs = allParagraphs.filter(function () {
                    return $(this).closest('table').length === 0;
                });
                let words = 0;
                let paragraphIndex = 0;
                let adSlotNumber = 2;
                let adsAdded = 0;

                // loop through the paragraphs
                while (paragraphIndex < paragraphs.length) {
                    // get the current paragraph
                    const paragraph = paragraphs.eq(paragraphIndex);
                    // get the words in the paragraph
                    const paragraphWords = paragraph.text().split(' ');
                    // if the words in the paragraph, plus the words we've already counted, is greater than the words per ad, then we need to add an ad
                    if (paragraphWords.length + words > wordsPerAd) {
                        // create the ad slot
                        const adSlotData = {
                            // format the slot id as inline-xx, ensuring we have 2 numbers, so inline-01, inline-02 etc
                            slotId: 'inline-' + (adSlotNumber < 10 ? '0' + adSlotNumber : adSlotNumber),
                            sizeMapping: sizeMappings,
                            paddingClass: 'pb-3'
                        }
                        // render the ad slot
                        const adSlotHtml = adSlotTemplate(adSlotData);
                        // append the ad slot to the paragraph
                        paragraph.after(adSlotHtml);

                        // reset the words
                        words = 0;
                        // increment the ad slot number
                        adSlotNumber++;
                        // increment the ads added
                        adsAdded++;
                    } else {
                        // otherwise, add the words in the paragraph to the words
                        words += paragraphWords.length;
                        // increment the paragraph index
                        paragraphIndex++;
                    }
                }

                // if we've not added any ads, then we need to add one at the end
                if (adsAdded === 0) {
                    // create the ad slot
                    const adSlotData = {
                        slotId: 'inline-' + (adSlotNumber < 10 ? '0' + adSlotNumber : adSlotNumber),
                        sizeMapping: sizeMappings,
                        paddingClass: 'pb-3'
                    }
                    // render the ad slot
                    const adSlotHtml = adSlotTemplate(adSlotData);
                    // append the ad slot to the paragraph
                    bodyCopy.append(adSlotHtml);
                }

                // mark the body copy as parsed
                bodyCopy.data('ads-parsed', true);
            }

        }
    }

    function parseKnownAds(thisAdSection, adSlotTemplate) {
        // parse any data-ad-data hidden fields and use the handlebars template to render it
        const adData = thisAdSection.find('[data-ad-data]');
        if (adData.length > 0) {

            // foreach adData, parse the json and render the template
            adData.each(function (index, element) {
                const adSlot = $(element);
                let adSlotData = adSlot.data('ad-data');
                const adSlotHtml = adSlotTemplate(adSlotData);
                adSlot.replaceWith(adSlotHtml);
            });
        }
    }


//$(function () {
    window.getDFPAdsPage = function (thisAdSection) {
        if (thisAdSection.length === 0) {
            return null;
        }
        parseKnownAds(thisAdSection, adSlotTemplate);

        setupInlineArticleAds(thisAdSection, adSlotTemplate);

        const adId = thisAdSection.data("ad-id");
        if (!pages[adId]) {
            pages[adId] = createAdsPage(thisAdSection, adId);
        }
        parseSlots(thisAdSection, pages[adId]);


        const href = window.location.href;
        const querystring = href.split('?')[1];
        if (typeof querystring === "undefined" || querystring === "") {
            const pageType = $('[data-ad-page-type]').data('ad-page-type');
            pages[adId].pageType = pageType;
        } else {
            const webpageType = $('[data-document-type]').data('document-type');
            pages[adId].pageType = webpageType;
        }
        return pages[adId];
    }


    window.initAds = function () {
        console.timeEnd('consentData');
        console.time('permutiveReady');
        window.permutive.readyWithTimeout(function () {
            const adSection = $("[data-ad-id]");
            const page = getDFPAdsPage(adSection);
            if (page) {
                window.dfpAdsPage = page;
                if (page.apsId) {
                    window.apstag.init({
                        pubID: page.apsId,
                        adServer: 'googletag'
                    });
                }
                getDFPAds(page);
                console.timeEnd('permutiveReady');
            }
        }, "realtime", 1500);

    };

    __tcfapi('addEventListener', 2, function (tcData, success) {
        console.timeEnd('CMP');
        if (success && tcData.eventStatus === 'cmpuishown') {
            console.log('SP: Surfacing CMP interface.');
        }

        if (success && tcData.eventStatus === 'useractioncomplete') {
            console.log('SP: User submitted consent choices.');
            consentData(tcData);
        }

        if (success && tcData.eventStatus === 'tcloaded') {
            console.log('SP: TC string available.');

            window.__tcfapi('removeEventListener', 2, function (success) {
                if (success) {
                    console.log('SP: Event listener removed.');
                }
            }, tcData.listenerId);

            consentData(tcData);
        }

    });
}

$(window).on('load', function () {
    var checkAd = setTimeout(function () {
        if ($('#inline-01-container').height() === 0) {
            console.log('Ad-blocker detected!');
            $("*").removeClass("sticky-dfp-ad");
        }
    }, 2000); // wait 2 seconds after the 'load' event
});

function setTargeting(gpt, thisPage) {
    gpt.pubads().setTargeting('pagetype', [thisPage.pageType]);
    gpt.pubads().setTargeting('cms_template_name', [thisPage.templateName]);
    gpt.pubads().setTargeting('page', [thisPage.page]);
    gpt.pubads().setTargeting('campaign_name', [thisPage.campaignName]);
    gpt.pubads().setTargeting('url', [thisPage.pageUrl]);
    gpt.pubads().setTargeting('title', [thisPage.pageTitle]);
    if (gpt.pubads().getTargeting('permutive').length === 0) {
        const kvs = localStorage.getItem('_pdfps');
        gpt.pubads().setTargeting('permutive', kvs ? JSON.parse(kvs) : []);
    }
}

function loadSlotsWithGpt(gpt, page, slots) {
    gpt.cmd.push(function () {
        function refreshAds() {
            if (gpt.pubadsReady) {
                setTargeting(gpt, page);
                gpt.pubads().refresh(slots);
                slots.forEach(slot => {
                    // console.log(slot.getSlotElementId())
                    console.timeLog(slot.getSlotElementId(), 'refresh called');
                })
            } else {
                console.log('awaiting pubadsReady')
                setTimeout(refreshAds, 100);
            }
        }

        // refreshing ads enabled for initial loading
        refreshAds();
    });
}

// function refreshLoadedAds(page, adSlots, slots) {
//     const gpt = window.googletag;
//
//     // GS - 2023-09-06 - disabling amazon bids as they aren't implemented in the new ad system
//     // if (page.apsId) {
//     //     const amazonSlots = $.map(adSlots,
//     //         function (e) {
//     //             return {
//     //                 slotID: e.holderId,
//     //                 slotName: e.dfpSlotName,
//     //                 sizes: [e.defaultSize]
//     //             }
//     //         });
//     //     window.apstag.fetchBids({
//     //             slots: amazonSlots,
//     //             timeout: 2e3
//     //         },
//     //         function (bids) {
//     //             gpt.cmd.push(function () {
//     //                 function refreshAds() {
//     //                     if (gpt.pubadsReady) {
//     //                         window.apstag.setDisplayBids();
//     //                         setTargeting(gpt, page)
//     //                         gpt.pubads().refresh(slots);
//     //                     } else {
//     //                         setTimeout(refreshAds, 200);
//     //                     }
//     //                 }
//     //
//     //                 // refreshing ads enabled for initial loading
//     //                 refreshAds();
//     //             });
//     //
//     //         });
//     // } else {
//     // }
// }

function initialLoadAds(gpt, page, slots) {
    gpt.cmd.push(function () {

        // slots.forEach(function (slot) {
        //     const slotName = slot.holderId;
        //     console.time(slotName);
        // });

        const eagerSlots = slots.filter(x => x.isEager).map(x => x.slot);
        const lazySlots = slots.filter(x => !x.isEager).map(x => x.slot);

        console.log('eager slots', eagerSlots);
        console.log('lazy slots', lazySlots);

        // if we have eager slots, then we want to load them first

        loadSlotsWithGpt(gpt, page, eagerSlots);

        gpt.cmd.push(function () {
            gpt.pubads().enableLazyLoad({
                fetchMarginPercent: 25,  // Fetch slots within 1 viewports.
                renderMarginPercent: 5,  // Render slots within 0.5 viewports.
                mobileScaling: 2  // Double the above values on mobile.
            });
        });

        // then we want to load the lazy slots
        loadSlotsWithGpt(gpt, page, lazySlots);

        gpt.pubads().addEventListener('slotRenderEnded', function (event) {
            console.log('Ad slot ' + event.slot.getSlotElementId() + ' rendered.');
        });
    });
}

function reloadAds(page) {
    if (!shouldReload) {
        return;
    }
    shouldReload = false;
    // only allow reload after 5 seconds
    setTimeout(function () {
        shouldReload = true
    }, 5000);

    const adSlots = page.adSlots;
    const slots = $.map(adSlots, function (e) {
        console.time(e.googleSlot.getSlotElementId());
        return {
            isEager: e.isEager,
            slot: e.googleSlot,
        }
    });
    const gpt = window.googletag;
    if (page.hadInitialLoad) {
        loadSlotsWithGpt(gpt, page, slots.map(x => x.slot));
    } else {
        initialLoadAds(gpt, page, slots);
    }

};
window.reloadCurrentPageAds = function () {
    if (window.dfpAdsPage) {
        reloadAds(window.dfpAdsPage);
    }
};

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function isScrolledIntoView(el) {
    const rect = el.getBoundingClientRect();
    if (rect.height === 0 && rect.width === 0) {
        return false;
    }
    const elemTop = rect.top;
    const elemBottom = rect.bottom;

    // Only completely visible elements return true:
    const isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight);
    // Partially visible elements return true:
    //isVisible = elemTop < window.innerHeight && elemBottom >= 0;
    return isVisible;
}

function refreshAdByName(name) {
    const gpt = window.googletag;
    gpt.cmd.push(function () {
        function refreshAd() {
            if (gpt.pubadsReady) {
                const slot = window.dfpAdsPage.adSlots[name];
                if (slot && slot.isInitialized) {
                    gpt.pubads().refresh([slot.googleSlot]);
                }
            } else {
                setTimeout(refreshAd, 200);
            }
        }

        // refreshing ads enabled for initial loading
        refreshAd();
    });

}

function getIndex(adSlot) {
    const slot = adSlot.slot;
    const hiddenColumn = slot.parents('[data-ads-hidden-column]');
    const holder = slot.parent();
    return hiddenColumn.find('[data-ad-slot-name]').index(holder);
}

function shouldAdd(adSlot) {
    // if it's not in a hidden column, we don't need to move it
    const hiddenColumn = adSlot.slot.parents('[data-ads-hidden-column]');
    if (hiddenColumn.length === 0)
        return false;

    return true;
}

function setupAdMovement(page) {
    const slotsToAdd = [];
    for (let name in page.adSlots) {
        if (page.adSlots.hasOwnProperty(name)) {
            var slot = page.adSlots[name];
            if (shouldAdd(slot))
                slotsToAdd.push(slot);
        }
    }

    if (slotsToAdd.length === 0)
        return;

    slotsToAdd.sort(function (a, b) {
        const indexA = getIndex(a);
        const indexB = getIndex(b);
        return indexA > indexB ? 1 : -1;
    });

    for (let k = 0; k < slotsToAdd.length; k++) {
        const adSlot = slotsToAdd[k];
        const slotName = adSlot.slotName;

        var slot = adSlot.slot;
        const desktopSlot = slot;
        let mobileReplacementSlot = page.mainColumn.find('[data-ad-mobile-replace="' + slotName + '"]');
        if (mobileReplacementSlot.length === 0) {
            mobileReplacementSlot = $('<div data-ad-mobile-replace="' + slotName + '" class="col-md-6 mb-3 text-center">');
            page.defaultAdHolder.append(mobileReplacementSlot);
        }
        mobileReplacementSlot.attr('data-responsive-movable-xs', slot.attr('data-responsive-movable'));
        mobileReplacementSlot.attr('data-responsive-movable-sm', slot.attr('data-responsive-movable'));
        const mobileSlot = mobileReplacementSlot.eq(0);
        page.desktopSlots[adSlot.holderId] = desktopSlot;
        page.mobileSlots[adSlot.holderId] = mobileSlot;
    }
    window.registerMovableElements($, true);
}

function getMobileAdSlotCount(thisPage) {
    let count = 0;
    for (let key in thisPage.mobileSlots) {
        count++;
    }
    return count;
}

function getMobileAdSlotKeys(thisPage) {
    const slots = [];
    for (let key in thisPage.mobileSlots) {
        if (thisPage.mobileSlots.hasOwnProperty(key)) {
            slots.push(key);
        }
    }
    slots.sort(function (a, b) {
        const indexA = getIndex(thisPage.adSlots[a]);
        const indexB = getIndex(thisPage.adSlots[b]);
        return indexA > indexB ? 1 : -1;
    });
    return slots;
}

function getSlot(thisPage, slots, index) {
    const slot = thisPage.mobileSlots[slots[index]].removeClass('col-md-6');
    return slot;
}

function moveMobileReplacementsToBodyCopy(page) {
    const mobileAdSlotCount = getMobileAdSlotCount(page);
    if (mobileAdSlotCount === 0)
        return;
    let bodyCopy = page.mainColumn.find('[data-ads-body-copy]');
    if (bodyCopy.length === 0)
        return;
    const first = parseInt(bodyCopy.data('ads-first'));
    if (Number.isNaN(first) || first < 0)
        return;
    const every = parseInt(bodyCopy.data('ads-every'));
    if (Number.isNaN(every) || every < 0)
        return;

    bodyCopy = bodyCopy.eq(0);
    const paragraphs = bodyCopy.find('p');
    if (first > paragraphs.length) {
        return;
    }

    let count = first;
    const slots = getMobileAdSlotKeys(page);
    paragraphs.eq(count).before(getSlot(page, slots, 0));
    count += every;

    for (let i = 1; i < slots.length; i++) {
        if (count > paragraphs.length) {
            return;
        }
        paragraphs.eq(count).before(getSlot(page, slots, i));
        count += every;
    }
}

function isMpu(slotName) {
    return slotName.indexOf('mpu') === 0;
}

function parseSlots(thisAdSection, thisPage) {
    const gpt = window.googletag;
    // get the current sections from the adslots 
    const currentSlots = Object.keys(thisPage.adSlots);

    // for each, check that the slot is still in the DOM
    currentSlots.forEach(function (slotName) {
        // get the element
        let adSlot = thisPage.adSlots[slotName];
        const element = adSlot.slot[0];
        // if the element doesn't exist, then remove it from the page
        if (element.length === 0) {
            delete thisPage.adSlots[slotName];
            // remove the slot from the page in GPT
            gpt.cmd.push(function () {
                gpt.destroySlots([adSlot.googleSlot]);
            });
            return;
        }

        // otherwise we want to traverse up the DOM to check that it's still in the body, using native JS
        let parent = element.parentElement;
        let bodyFound = false;
        while (parent) {
            if (parent.tagName === 'BODY') {
                bodyFound = true;
                break;
            }
            parent = parent.parentElement;
        }
        // if we didn't find the body, then remove the slot
        if (!bodyFound) {
            delete thisPage.adSlots[slotName];
            // remove the slot from the page in GPT
            gpt.cmd.push(function () {
                gpt.destroySlots([adSlot.googleSlot]);
            });
        }
    });

    // otherwise, parse the slots that are there
    thisAdSection.find("[data-ad-slot-name]").each(function (index, element) {
        const adHolder = $(element).find("[data-ad-holder]");
        const holderId = adHolder.attr("id");
        // if we don't have a holder id, then we can't do anything
        if (typeof holderId === "undefined" || holderId === null || holderId === "")
            return;

        // if the holder id is already in the page, then we don't need to do anything
        if (thisPage.adSlots[holderId])
            return;

        const container = adHolder.parent();

        const slotName = $(element).data('ad-slot-name');
        const defaultWidth = $(element).data('ad-slot-default-width');
        const defaultHeight = $(element).data('ad-slot-default-height');
        const isFluid = $(element).data('ad-slot-is-fluid');
        const sizeMapping = $(element).data('ad-slot-size-mapping');
        const unpinDelay = $(element).data('ad-slot-unpin-delay');
        const outOfPage = $(element).data('ad-slot-out-of-page');
        const isEager = $(element).data('ad-slot-is-eager');

        // otherwise, add the slot to the page
        thisPage.adSlots[holderId] = {
            container,
            element,
            slot: $(element),
            adHolder: adHolder,
            holderId: holderId,
            slotName: slotName,
            defaultSize: isFluid ? ['fluid'] : [defaultWidth, defaultHeight],
            sizeMapping: sizeMapping,
            isInitialized: false,
            isViewed: false,
            isUnpinned: false,
            unpinDelay: unpinDelay,
            outOfPage: outOfPage,
            isEager: isEager
        };
    });
}

function createAdsPage(thisAdSection, adId) {
    const thisPage = {};
    thisPage.hadInitialLoad = false;
    thisPage.id = adId;
    thisPage.site = thisAdSection.data('ad-site');
    thisPage.slotName = thisAdSection.data('ad-page');
    thisPage.page = thisPage.slotName.replace(/^\/|\/$/g, '').replace(/&/g, "");
    if (!thisPage.page) {
        thisPage.page = "home";
    }
    thisPage.pageType = thisAdSection.data('ad-page-type');
    thisPage.templateName = thisAdSection.data('ad-template-name');
    thisPage.campaignName = thisAdSection.data('ad-campaign-name');
    thisPage.pageUrl = thisAdSection.data('ad-page-url');
    thisPage.pageTitle = thisAdSection.data('page-title');
    thisPage.amp = thisAdSection.data('amp-page');
    thisPage.contentArea = thisAdSection;
    thisPage.mainColumn = thisAdSection.find("[data-ads-main-column]").eq(0);
    thisPage.defaultAdHolder = $('<div class="row">');
    thisPage.maxPinTime = thisAdSection.data('ad-max-pin-time') || 5000;

    thisPage.apsId = thisAdSection.data('ad-aps-id');

    thisPage.adSlots = {};

    thisPage.mainColumn.append(thisPage.defaultAdHolder);
    thisPage.desktopSlots = {};
    thisPage.mobileSlots = {};

    return thisPage;
}
//Store and/or access information on a device (purpose) = 1
//Select personalised ads(purpose) = 4
//Create a personalised ads profile (purpose) = 3
//Bauer Media(vendor) = 5f8036e6145f6b2baf93e3d6
function consentData(tcData) {
    console.time('consentData');

    // Check if GDPR applies
    if (tcData.gdprApplies === true) {
        console.log("GDPR applies. Processing consent data...");

        __tcfapi('getCustomVendorConsents', 2, function (vendorConsents, success) {
            console.log(vendorConsents);

            if (typeof vendorConsents !== 'undefined' && vendorConsents !== null) {
                const bauerMedia = vendorConsents.grants?.["5f8036e6145f6b2baf93e3d6"]?.vendorGrant;

                // Check if `purpose` and `purpose.consents` exist
                if (typeof tcData.purpose === 'undefined' || typeof tcData.purpose.consents === 'undefined') {
                    console.warn('Purpose or Purpose Consents is undefined in tcData');
                    window.permutive.consent({ "opt_in": false });
                    window.initAds();
                } else {
                    if (tcData.purpose.consents[1] !== true ||
                        tcData.purpose.consents[3] !== true ||
                        tcData.purpose.consents[4] !== true ||
                        bauerMedia !== true) {
                        window.permutive.consent({ "opt_in": false });
                        window.initAds();
                    } else {
                        window.permutive.consent({ "opt_in": true, "token": "CONSENT_CAPTURED" });
                        window.initAds();
                    }
                }
            } else {
                console.warn('Vendor Consents is undefined or null');
                window.permutive.consent({ "opt_in": false });
                window.initAds();
            }
        });
    } else {
        console.log("GDPR does not apply. Defaulting to opt-in behavior.");
        // Handle non-GDPR regions
        window.permutive.consent({ "opt_in": true });
        window.initAds();
    }

    console.timeEnd('consentData');
}